import { SpecialSkill, NormalSkill, PassiveSkill } from './skills';

export enum FishType {
	Random,
	BlueShark,
	GreatWhiteShark,
	Megalodon,
	KillerWhale,
	SerialKillerWhale,
	PsychoKillerWhale,
	HammerHead,
	HammeredHead,
	WhammyHead,
	HumpbackWhale,
	BlueWhale,
	Jomama,
	MantaRay,
	MantraRay,
	BlueRay,
	Pufferfish,
	Porcupinefish,
	Onifugu,
	BottlenoseDolphin,
	CommonDolphin,
	SpinnerDolphin,
	Goldfish,
	Goldenfish,
	Diamondfish,
	Narwhal,
	Beluga,
	ArchBeluga,
	DumboOctopus,
	Tako,
	Kraken,
	MorayEel,
	GulperEel,
	ElectricEel,
	GreenSeaTurtle,
	LeatherbackTurtle,
	AlligatorSnappingTurtle,
	Stingray,
	BatRay,
	ElectricRay,
	SakuraShrimp,
	PistolShrimp,
	MantisShrimp,
	FirebellyNewt,
	FireSalamander,
	Axolotl,
	VampireSquid,
	Cuttlefish,
	ColossalSquid,
	Swordfish,
	Marlin,
	Sailfish,
	BlueCrab,
	KingCrab,
	SpiderCrab,
	Crocodile,
	Kronosaurus,
	Mosasaurus,
}

export type FishFamily = 'Random' | 'Shark' | 'Whale' | 'Dolphin' | 'Narwhal' | 'Ray' | 'Pufferfish' | 'Carp' | 'Knifefish' | 'Cephalopod' | 'Eel' | 'Turtle' | 'Crustacean' | 'Mesozoic' | 'Mythical' | 'Amphibian' | 'Swordfish' | 'Reptile';
export type FishColor = 'Random' | 'Green' | 'Blue' | 'Red' | 'Black' | 'Purple' | 'Yellow' | 'White' | 'All';
export type UnlockType = 'skill' | 'item';
export interface UnlockCondition { condition: string, maxCount?: number, }

export interface FishPassiveSkill {
	type: PassiveSkill,
	lvl: number,
}

export interface FishInfo extends Submission {
	type: FishType,
}

interface Submission {
	name: string,
	tier: number,
	desc: string,
	family: FishFamily[],
	color: FishColor[],
	stat: {
		size: number,
		attack: number,
		defense: number,
		health: number,
		speed: number,
		boostSpeed: number,
		torque: number,
		stunPower: number,
		stunRes: number,
		stunRec: number,
	};
	skill1: NormalSkill,
	skill2: SpecialSkill,
	genes: FishPassiveSkill[],
	passives: FishPassiveSkill[],
}

export const fishInfos: FishInfo[] = [];

// max size 1.4

function setInfo(type: FishType, submission: Submission) {
	fishInfos[type] = submission as any;
	fishInfos[type].type = type;
}
setInfo(FishType.Random, {
	name: 'Random',
	tier: 0,
	desc: '',
	family: ['Random'],
	color: ['Random'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.None,
	skill2: SpecialSkill.None,
	genes: [],
	passives: [],
});
setInfo(FishType.BlueShark, {
	name: 'Blue Shark',
	tier: 1,
	desc: 'Overall balanced. Quick at earning scores.',
	family: ['Shark'],
	color: ['Blue'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.ScoreBonus, lvl: 2 }],
	passives: [],
});
setInfo(FishType.GreatWhiteShark, {
	name: 'Great White Shark',
	tier: 2,
	desc: 'Strong attack',
	family: ['Shark'],
	color: ['Blue'],
	stat: {
		size: 1.15,
		attack: 105,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.ScoreBonus, lvl: 1 }, { type: PassiveSkill.AttackUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Megalodon, {
	name: 'Megalodon',
	tier: 3,
	desc: 'Very strong attack. Powerful Special Attack.',
	family: ['Shark'],
	color: ['Red'],
	stat: {
		size: 1.3,
		attack: 125,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.MegaBite,
	genes: [],
	passives: [],
});
setInfo(FishType.KillerWhale, {
	name: 'Killer Whale',
	tier: 1,
	desc: 'Killing grants bonus score.',
	family: ['Dolphin'],
	color: ['Black'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.KillScoreBonus, lvl: 2 }],
	passives: [],
});
setInfo(FishType.SerialKillerWhale, {
	name: 'Serial Killer Whale',
	tier: 2,
	desc: 'Decent attack. Good at tracking champion\'s location',
	family: ['Dolphin'],
	color: ['Black'],
	stat: {
		size: 1.15,
		attack: 110,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.KillChampHunt, lvl: 1 }],
	passives: [],
});
setInfo(FishType.PsychoKillerWhale, {
	name: 'Psycho Killer Whale',
	tier: 3,
	desc: 'Strong Attack. Annoying special skill.',
	family: ['Dolphin'],
	color: ['Purple'],
	stat: {
		size: 1.25,
		attack: 120,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.SwimmingFang,
	genes: [],
	passives: [],
});
setInfo(FishType.HammerHead, {
	name: 'HammerHead',
	tier: 1,
	desc: 'Wide eyes position helps with great eyesight.',
	family: ['Shark'],
	color: ['Green'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.SightRadiusUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.HammeredHead, {
	name: 'Hammered Head',
	tier: 2,
	desc: 'Can use bandages to heal a good portion of HP.',
	family: ['Shark'],
	color: ['Yellow'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 350,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Bandage,
	genes: [{ type: PassiveSkill.Friendship, lvl: 1 }],
	passives: [],
});
setInfo(FishType.WhammyHead, {
	name: 'Whammy Head',
	tier: 3,
	desc: 'Can release a shockwave to stun nearby enemies.',
	family: ['Shark'],
	color: ['Purple'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.WhammyWave,
	genes: [],
	passives: [],
});
setInfo(FishType.Narwhal, {
	name: 'Narwhal',
	tier: 1,
	desc: 'The original stabfish. Has longer weapon.',
	family: ['Narwhal'],
	color: ['Blue'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.WpnSizeUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.Beluga, {
	name: 'Beluga',
	tier: 2,
	desc: 'An arctic stabfish that resist to cold. Has strong stamina for migration.',
	family: ['Narwhal'],
	color: ['White'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.IceResUp, lvl: 1 }, { type: PassiveSkill.Adrenaline, lvl: 1 }],
	passives: [],
});
setInfo(FishType.ArchBeluga, {
	name: 'ArchBeluga',
	tier: 3,
	desc: 'God\'s messenger. Yields Holy Sword to deliver the judgement.',
	family: ['Narwhal'],
	color: ['White'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.HolySword,
	genes: [],
	passives: [],
});
setInfo(FishType.BottlenoseDolphin, {
	name: 'Bottlenose Dolphin',
	tier: 1,
	desc: 'Fast swimmer. Teammates receive small amount of healing effetcs.',
	family: ['Dolphin'],
	color: ['Blue'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.SpeedUp, lvl: 1 }, { type: PassiveSkill.Friendship, lvl: 1 }],
	passives: [],
});
setInfo(FishType.CommonDolphin, {
	name: 'Common Dolphin',
	tier: 2,
	desc: 'Teammates receive decent amount of healing effetcs.',
	family: ['Dolphin'],
	color: ['Green'],
	stat: {
		size: 1.1,
		attack: 100,
		defense: 25,
		health: 350,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.Friendship, lvl: 2 }],
	passives: [],
});
setInfo(FishType.SpinnerDolphin, {
	name: 'Spinner Dolphin',
	tier: 3,
	desc: 'Dodges enemy\'s attack with graceful spins.',
	family: ['Dolphin'],
	color: ['Blue'],
	stat: {
		size: 1.2,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1.05,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.SpinDodge,
	genes: [],
	passives: [],
});
setInfo(FishType.MantaRay, {
	name: 'Manta Ray',
	tier: 1,
	desc: 'Good at converting food to score.',
	family: ['Ray'],
	color: ['Black'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.FoodScoreUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.MantraRay, {
	name: 'Mantra Ray',
	tier: 2,
	desc: 'A peace activist that can create a temporary neutral zone.',
	family: ['Ray'],
	color: ['Red'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.TempSafeZone,
	genes: [{ type: PassiveSkill.FoodScoreUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.BlueRay, {
	name: 'Blue Ray',
	tier: 3,
	desc: 'Has psychic power to generate a huge force field to keep enemies out of reach.',
	family: ['Ray'],
	color: ['Blue'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.ForceField,
	genes: [],
	passives: [],
});
setInfo(FishType.DumboOctopus, {
	name: 'Dumbo Octopus',
	tier: 1,
	desc: 'Quick at getting things done with 8 tentacles.',
	family: ['Cephalopod'],
	color: ['Yellow'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.CastTimeDown, lvl: 2 }],
	passives: [],
});
setInfo(FishType.Tako, {
	name: 'Tako',
	tier: 2,
	desc: 'Shoot ink to blind enemies temporarily.',
	family: ['Cephalopod'],
	color: ['Red'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.InkSac,
	genes: [{ type: PassiveSkill.CastTimeDown, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Kraken, {
	name: 'Kraken',
	tier: 3,
	desc: 'Mythical beast! Sacrifice impaled victim to gain God-like power!',
	family: ['Mythical'],
	color: ['Green'],
	stat: {
		size: 1.35,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Sacrifice,
	genes: [],
	passives: [],
});
setInfo(FishType.HumpbackWhale, {
	name: 'Humpback Whale',
	tier: 1,
	desc: 'Attract faraway foods with the big mouth. Decent HP.',
	family: ['Whale'],
	color: ['Black'],
	stat: {
		size: 1.1,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.FoodMagnet, lvl: 2 }],
	passives: [],
});
setInfo(FishType.BlueWhale, {
	name: 'Blue Whale',
	tier: 2,
	desc: 'Attract nearby foods with the big mouth. Great HP.',
	family: ['Whale'],
	color: ['Blue'],
	stat: {
		size: 1.2,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.FoodMagnet, lvl: 1 }, { type: PassiveSkill.MaxHpUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Jomama, {
	name: 'Jomama',
	tier: 3,
	desc: 'Use body slam to rescue impaled children. Great HP.',
	family: ['Whale'],
	color: ['Yellow'],
	stat: {
		size: 1.3,
		attack: 100,
		defense: 25,
		health: 600,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.BodySlam,
	genes: [],
	passives: [],
});
setInfo(FishType.Pufferfish, {
	name: 'Puffer Fish',
	tier: 1,
	desc: 'Covered with short spikes',
	family: ['Pufferfish'],
	color: ['Green'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.ScoreBonus, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Porcupinefish, {
	name: 'Porcupine Fish',
	tier: 2,
	desc: 'Covered with dangerous spikes',
	family: ['Pufferfish'],
	color: ['Yellow'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [],
	passives: [],
});
setInfo(FishType.Onifugu, {
	name: 'Onifugu',
	tier: 3,
	desc: 'Covered with dangerous spikes, grow larger when angered.',
	family: ['Pufferfish'],
	color: ['Red'],
	stat: {
		size: 1.2,
		attack: 125,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.SpikeArmor,
	genes: [],
	passives: [],
});
setInfo(FishType.MorayEel, {
	name: 'Moray Eel',
	tier: 1,
	desc: 'Has the ability to use special skill again sooner.',
	family: ['Eel'],
	color: ['Green'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.CoolDownTimeDown, lvl: 2 }],
	passives: [],
});
setInfo(FishType.GulperEel, {
	name: 'Gulper Eel',
	tier: 2,
	desc: 'Bioluminence on tail reduce the effect of blindness',
	family: ['Eel'],
	color: ['Purple'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.CoolDownTimeDown, lvl: 1 }, { type: PassiveSkill.BlindResUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.ElectricEel, {
	name: 'Electric Eel',
	tier: 3,
	desc: 'Release Electric Charge to shock surrounding enemies.',
	family: ['Knifefish'],
	color: ['Blue'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.ElectricField,
	genes: [],
	passives: [],
});
setInfo(FishType.Goldfish, {
	name: 'Goldfish',
	tier: 1,
	desc: 'A fish that good with money.',
	family: ['Carp'],
	color: ['Red'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.MoneyUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.Goldenfish, {
	name: 'Goldenfish',
	tier: 2,
	desc: 'Decent defense. Good at finding legendary ores.',
	family: ['Carp'],
	color: ['Yellow'],
	stat: {
		size: 1.15,
		attack: 95,
		defense: 30,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.OreRarityUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.Diamondfish, {
	name: 'Diamondfish',
	tier: 3,
	desc: 'Good defense. Harden it\'s skin when in danger.',
	family: ['Carp'],
	color: ['White'],
	stat: {
		size: 1.25,
		attack: 90,
		defense: 35,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.DiamondHarden,
	genes: [],
	passives: [],
});
setInfo(FishType.GreenSeaTurtle, {
	name: 'Green Sea Turtle',
	tier: 1,
	desc: 'Good defense and has a long life.',
	family: ['Turtle'],
	color: ['Green'],
	stat: {
		size: 1,
		attack: 90,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.DefenseUp, lvl: 1 }, { type: PassiveSkill.MaxHpUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.LeatherbackTurtle, {
	name: 'Leatherback Turtle',
	tier: 2,
	desc: 'Good defense and migrate far.',
	family: ['Turtle'],
	color: ['Green'],
	stat: {
		size: 1.1,
		attack: 90,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.DefenseUp, lvl: 1 }, { type: PassiveSkill.Adrenaline, lvl: 1 }],
	passives: [],
});
setInfo(FishType.AlligatorSnappingTurtle, {
	name: 'Alligator Snapping Turtle',
	tier: 3,
	desc: 'Good defense. Hide in it\'s tough shell when in danger.',
	family: ['Turtle'],
	color: ['Yellow'],
	stat: {
		size: 1.2,
		attack: 90,
		defense: 35,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.ShellHiding,
	skill2: SpecialSkill.Burst,
	genes: [],
	passives: [],
});
setInfo(FishType.Stingray, {
	name: 'Stingray',
	tier: 1,
	desc: 'A dart shooter that tracks down whoever killed them and gets extra points for exacting vengeance.',
	family: ['Ray'],
	color: ['Purple'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost2,
	skill2: SpecialSkill.Dart,
	genes: [{ type: PassiveSkill.Revenger, lvl: 1 }],
	passives: [],
});
setInfo(FishType.BatRay, {
	name: 'Bat Ray',
	tier: 2,
	desc: 'A dart shooter that increases amount of tool-based special skill items.',
	family: ['Ray'],
	color: ['Blue'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost2,
	skill2: SpecialSkill.BatDart,
	genes: [{ type: PassiveSkill.UtilityBelt, lvl: 1 }],
	passives: [],
});
setInfo(FishType.ElectricRay, {
	name: 'Electric Ray',
	tier: 3,
	desc: 'Shoots electric charged darts.',
	family: ['Ray'],
	color: ['Yellow'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost2,
	skill2: SpecialSkill.ElectricDart,
	genes: [],
	passives: [],
});
setInfo(FishType.SakuraShrimp, {
	name: 'Sakura Shrimp',
	tier: 1,
	desc: 'Has small body and good with stamina.',
	family: ['Crustacean'],
	color: ['Red'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.BodySizeDown, lvl: 1 }, { type: PassiveSkill.Adrenaline, lvl: 1 }],
	passives: [],
});
// max body size -50%, weapon size -50%, speed +50%
setInfo(FishType.PistolShrimp, {
	name: 'Pistol Shrimp',
	tier: 2,
	desc: 'Shoots mid-range exploding fire bullet.',
	family: ['Crustacean'],
	color: ['Red'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.FireBullet,
	genes: [],
	passives: [],
});
setInfo(FishType.MantisShrimp, {
	name: 'Mantis Shrimp',
	tier: 3,
	desc: 'Punch so fast that a mini sun is created',
	family: ['Crustacean'],
	color: ['All'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.SunPunch,
	genes: [],
	passives: [],
});
setInfo(FishType.FirebellyNewt, {
	name: 'Fire-belly Newt',
	tier: 1,
	desc: 'Has ability to regenerate from wounds over time',
	family: ['Amphibian'],
	color: ['Black'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.HpRegenUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.FireSalamander, {
	name: 'Fire Salamander',
	tier: 2,
	desc: 'A regenerating amphibian with high fire resistance.',
	family: ['Amphibian'],
	color: ['Yellow'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.FireResUp, lvl: 1 }, { type: PassiveSkill.HpRegenUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Axolotl, {
	name: 'Axolotl',
	tier: 3,
	desc: 'Can cut tail to escape impalement.',
	family: ['Amphibian'],
	color: ['Red'],
	stat: {
		size: 1.2,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Decoy,
	genes: [],
	passives: [],
});
setInfo(FishType.VampireSquid, {
	name: 'Vampire Squid',
	tier: 1,
	desc: 'Has ability to suck impaled victim\'s blood for health and stamina.',
	family: ['Cephalopod'],
	color: ['Red'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.Leech, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Cuttlefish, {
	name: 'Cuttlefish',
	tier: 2,
	desc: 'Has ability to disguise as an ironmonite or zellyfish.',
	family: ['Cephalopod'],
	color: ['Yellow'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Disguise,
	genes: [],
	passives: [],
});
setInfo(FishType.ColossalSquid, {
	name: 'Colossal Squid',
	tier: 3,
	desc: 'Use tentacles to push or pull opponents or other objects.',
	family: ['Cephalopod'],
	color: ['Purple'],
	stat: {
		size: 1.34,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.TentaBola,
	genes: [],
	passives: [],
});
setInfo(FishType.Swordfish, {
	name: 'Swordfish',
	tier: 1,
	desc: 'Has explosive boost ability.',
	family: ['Swordfish'],
	color: ['Blue'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.BoostSpeedUp, lvl: 2 }],
	passives: [],
});
setInfo(FishType.Marlin, {
	name: 'Marlin',
	tier: 2,
	desc: 'Fast swimmer with good boost.',
	family: ['Swordfish'],
	color: ['Blue'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 350,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.BoostSpeedUp, lvl: 1 }, { type: PassiveSkill.SpeedUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Sailfish, {
	name: 'Sailfish',
	tier: 3,
	desc: 'Summons all its weapons and dance with them.',
	family: ['Swordfish'],
	color: ['Blue'],
	stat: {
		size: 1.25,
		attack: 100,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1.05,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.SwordDance,
	genes: [],
	passives: [],
});
setInfo(FishType.BlueCrab, {
	name: 'Blue Crab',
	tier: 1,
	desc: 'Good defense and has special defense against nemesis, mobs and bosses.',
	family: ['Crustacean'],
	color: ['Blue'],
	stat: {
		size: 1,
		attack: 90,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.DefenseUp, lvl: 1 }, { type: PassiveSkill.DefenseUpNemesis, lvl: 1 }],
	passives: [],
});
setInfo(FishType.KingCrab, {
	name: 'King Crab',
	tier: 2,
	desc: 'Strong defense against nemesis, mobs and bosses.',
	family: ['Crustacean'],
	color: ['Red'],
	stat: {
		size: 1.1,
		attack: 90,
		defense: 30,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.DefenseUpNemesis, lvl: 2 }],
	passives: [],
});
setInfo(FishType.SpiderCrab, {
	name: 'Spider Crab',
	tier: 3,
	desc: 'Good defense. Capture and control an enemy with its long claws.',
	family: ['Crustacean'],
	color: ['Red'],
	stat: {
		size: 1.2,
		attack: 90,
		defense: 35,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.StrongArms,
	genes: [],
	passives: [],
});

setInfo(FishType.Crocodile, {
	name: 'Crocodile',
	tier: 1,
	desc: 'Expert at exploiting Nemesis and Mobs\' weaknesses.',
	family: ['Reptile'],
	color: ['Green'],
	stat: {
		size: 1,
		attack: 100,
		defense: 25,
		health: 300,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration,
	genes: [{ type: PassiveSkill.AttackUpNemesis, lvl: 2 }],
	passives: [],
});
setInfo(FishType.Kronosaurus, {
	name: 'Kronosaurus',
	tier: 2,
	desc: 'Excel in the art of inflicting damage.',
	family: ['Reptile'],
	color: ['Yellow'],
	stat: {
		size: 1.15,
		attack: 100,
		defense: 25,
		health: 400,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.Ration2,
	genes: [{ type: PassiveSkill.AttackUpNemesis, lvl: 1 }, { type: PassiveSkill.AttackUp, lvl: 1 }],
	passives: [],
});
setInfo(FishType.Mosasaurus, {
	name: 'Mosasaurus',
	tier: 3,
	desc: 'Strong attack. equipped with teeth capable of shattering foes\' weaponry.',
	family: ['Reptile'],
	color: ['Green'],
	stat: {
		size: 1.3,
		attack: 125,
		defense: 25,
		health: 500,
		speed: 1,
		boostSpeed: 1,
		torque: 1,
		stunRec: 1,
		stunRes: 1,
		stunPower: 1,
	},
	skill1: NormalSkill.Boost,
	skill2: SpecialSkill.MosaBite,
	genes: [],
	passives: [],
});

export const availableFishes = [
	fishInfos[FishType.BlueShark],
	fishInfos[FishType.GreatWhiteShark],
	fishInfos[FishType.Megalodon],
	fishInfos[FishType.HammerHead],
	fishInfos[FishType.HammeredHead],
	fishInfos[FishType.WhammyHead],
	fishInfos[FishType.KillerWhale],
	fishInfos[FishType.SerialKillerWhale],
	fishInfos[FishType.PsychoKillerWhale],
	fishInfos[FishType.BottlenoseDolphin],
	fishInfos[FishType.CommonDolphin],
	fishInfos[FishType.SpinnerDolphin],
	fishInfos[FishType.Pufferfish],
	fishInfos[FishType.Porcupinefish],
	fishInfos[FishType.Onifugu],
	fishInfos[FishType.Narwhal],
	fishInfos[FishType.Beluga],
	fishInfos[FishType.ArchBeluga],
	fishInfos[FishType.Goldfish],
	fishInfos[FishType.Goldenfish],
	fishInfos[FishType.Diamondfish],
	fishInfos[FishType.GreenSeaTurtle],
	fishInfos[FishType.LeatherbackTurtle],
	fishInfos[FishType.AlligatorSnappingTurtle],
	fishInfos[FishType.HumpbackWhale],
	fishInfos[FishType.BlueWhale],
	fishInfos[FishType.Jomama],
	fishInfos[FishType.DumboOctopus],
	fishInfos[FishType.Tako],
	fishInfos[FishType.Kraken],
	fishInfos[FishType.MantaRay],
	fishInfos[FishType.MantraRay],
	fishInfos[FishType.BlueRay],
	fishInfos[FishType.MorayEel],
	fishInfos[FishType.GulperEel],
	fishInfos[FishType.ElectricEel],
	fishInfos[FishType.Stingray],
	fishInfos[FishType.BatRay],
	fishInfos[FishType.ElectricRay],
	fishInfos[FishType.SakuraShrimp],
	fishInfos[FishType.PistolShrimp],
	fishInfos[FishType.MantisShrimp],
	fishInfos[FishType.FirebellyNewt],
	fishInfos[FishType.FireSalamander],
	fishInfos[FishType.Axolotl],
	fishInfos[FishType.VampireSquid],
	fishInfos[FishType.Cuttlefish],
	fishInfos[FishType.ColossalSquid],
	fishInfos[FishType.Swordfish],
	fishInfos[FishType.Marlin],
	fishInfos[FishType.Sailfish],
	fishInfos[FishType.BlueCrab],
	fishInfos[FishType.KingCrab],
	fishInfos[FishType.SpiderCrab],
	fishInfos[FishType.Crocodile],
	fishInfos[FishType.Kronosaurus],
	fishInfos[FishType.Mosasaurus],
];

export const availableFishesIncludesRandom = [
	fishInfos[FishType.Random],
	...availableFishes,
];

export const fishTiers = [
	availableFishes.filter((f) => f.tier === 1),
	availableFishes.filter((f) => f.tier === 2),
	availableFishes.filter((f) => f.tier === 3),
];
export const fishTiersForNms = [
	fishTiers[0],
	fishTiers[1],
	fishTiers[2],
];
export const fishTiersAndBelow = [
	availableFishes.filter((f) => f.tier === 1),
	availableFishes.filter((f) => f.tier <= 2),
	availableFishes.filter((f) => f.tier <= 3),
];

export const fishTiersType = [
	fishTiersAndBelow[0].map((f) => f.type),
	fishTiersAndBelow[1].map((f) => f.type),
	fishTiersAndBelow[2].map((f) => f.type),
];

export const cpsFishTiersAndBelow = [
	fishTiersAndBelow[0],
	fishTiersAndBelow[1],
	availableFishes.filter((f) => f.tier === 3 || f.tier === 2),
];
export const cpsFishTiersType = [
	fishTiersType[0],
	fishTiersType[1],
	cpsFishTiersAndBelow[2].map((f) => f.type),
];

